import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {DbMigrationStatusKind} from '../enum/db.migration.status.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {DbEntity} from './db.entity';

@EntityTable('db_migration', '61401cf5-c4b6-4279-af12-6fe84e49b22a')
export class DbMigrationEntity extends Entity {

    @Column(FieldTypeKind.LONG)
    public kind: number;

    @Column(FieldTypeKind.LONG)
    public status: DbMigrationStatusKind;

    @Column(FieldTypeKind.ANY)
    public data: any;

    @JoinColumn(FieldTypeKind.GUID, DbEntity, true, false, FieldRelationKind.BELONGS_TO, 'database')
    public dbId: string;

    @Column(FieldTypeKind.DATE)
    public executeAt: Date;


}
